export default __webpack_public_path__ + "static/media/squiggle.e2c5344d.png";